import type { TabDefinition, ValidUiModel } from "src/lib/tabs/types.ts";
import type { Router } from "@remix-run/router";
import { matchRoutes } from "react-router-dom";
import { normalizePathname } from "src/lib/tabs/normalizePathname.ts";

export const convertPathToUiModel = <
  UiModel extends ValidUiModel = ValidUiModel,
>({
  router,
  path,
  config,
}: {
  router: Router;
  path: string;
  config: TabDefinition<UiModel>[];
}): UiModel | undefined => {
  const matches = matchRoutes(router.routes, path) || [];

  for (let i = matches.length - 1; i > -1; i--) {
    const match = matches[i];
    for (let i = 0; i < config.length; i++) {
      const def = config[i];
      if (def.shouldOpen(match)) {
        const id = normalizePathname(match.pathname);
        return def.mapToUiModel(id, match, path);
      }
    }
  }

  return undefined;
};
